import type { SeriesOption, XAXisComponentOption } from 'echarts';
import type { TitleOption } from 'echarts/types/dist/shared';

export const TITLE_STYLES: TitleOption = {
  textStyle: {
    fontWeight: 'lighter',
    fontSize: 12,
    fontFamily: 'Roboto',
  },
  left: 'center',
};

export const CONFIDENCE_STYLES: SeriesOption = {
  type: 'line',
  smooth: true,
  lineStyle: {
    opacity: 0,
  },
  symbol: 'none',
};

export const X_AXIS_STYLE = {
  axisPointer: {
    z: 100,
  },
  type: 'time',
  show: true,
  axisLine: {
    show: true,
  },
  axisTick: {
    show: true,
  },
  splitLine: { show: true },
} as XAXisComponentOption;

const Y_AXIS_PRECISION = 3;

export const Y_AXIS_STYLE = {
  type: 'value',
  max: 'dataMax',
  splitNumber: 2,
  alignTicks: false,
  axisLine: {
    show: true,
  },
  splitLine: {
    show: true,
  },
  axisLabel: {
    width: '10px',
    overflow: 'breakAll',
    hideOverlap: true,
    show: true,
    formatter: (value: number) => value.toFixed(Y_AXIS_PRECISION),
  },
};
export const MARK_LINE_SERIES_STYLES = {
  symbol: 'none',
  symbolSize: 20,
  precision: 2,
  lineStyle: {
    type: 'solid',
  },
};
export const SERIES_STYLES = {
  type: 'line',
  symbol: 'circle',
  symbolSize: 2,
  smooth: true,
  z: 2,
  lineStyle: {
    join: 'round',
    opacity: '1',
  },
  emphasis: {
    itemStyle: {},
  },
  areaStyle: {
    opacity: 0,
  },
};

export const SERIES_STYLES_MAP: { [x: string]: any } = {
  line: { ...SERIES_STYLES },
  scatter: {
    type: 'scatter',
  },
  pie: {
    type: 'pie',
  },
};
